import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { FiX } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import {
  getViewProfile,
  updateProfile,
} from "../../../redux/slices/profileSlice";

const EmrSystemsModal = ({
  show,
  onHide,
  value = [],
  onSave,
  isApplyPage = false,
  shouldUpdateProfile = false,
}) => {
  const dispatch = useDispatch();
  const store = useSelector((state) => state.profile);

  const [selectedOptions, setSelectedOptions] = useState([]);
  const [error, setError] = useState("");

  const emrOptions = [
    { value: "Epic", label: "Epic" },
    { value: "Cerner", label: "Cerner" },
    { value: "Meditech", label: "Meditech" },
    { value: "Allscripts", label: "Allscripts" },
  ];
  useEffect(() => {
    if (show) {
      // dispatch(getViewProfile());
    }
  }, [show, dispatch]);
  /* -------- LOAD EXISTING VALUES -------- */
  useEffect(() => {
    if (!show) return;

    if (isApplyPage) {
      setSelectedOptions(value || []);
    } else {
      const current = store?.profileItem?.data?.nurseProfile?.emr_systems;

      if (current) {
        let parsed = [];

        try {
          parsed = Array.isArray(current) ? current : JSON.parse(current);
        } catch {
          parsed = current.split(",");
        }

        setSelectedOptions(parsed);
      }
    }
  }, [show, isApplyPage, value, store]);
  // useEffect(() => {
  //   if (!show) return;

  //   if (isApplyPage) {
  //     setSelectedOptions(value || []);
  //   } else {
  //     const current = store?.profileItem?.data?.nurseProfile?.emr_systems || [];

  //     setSelectedOptions(current);
  //   }
  // }, [show, isApplyPage]);

  /* -------- SELECT / DESELECT -------- */
  const handleSelect = (value) => {
    setError("");

    if (selectedOptions.includes(value)) {
      setSelectedOptions(selectedOptions.filter((v) => v !== value));
    } else {
      setSelectedOptions([...selectedOptions, value]);
    }
  };

  /* -------- SAVE -------- */
  const handleSave = () => {
    if (!selectedOptions.length) {
      setError("Please select at least one EMR system");
      return;
    }

    if (isApplyPage) {
      // ✅ ALWAYS update local
      onSave(selectedOptions);

      // 🔥 ONLY call API if empty before
      if (shouldUpdateProfile) {
        const formData = new FormData();

        formData.append(
          "name",
          store?.profileItem?.data?.name ||
            store?.profileItem?.data?.full_name ||
            "",
        );

        formData.append("emr_systems", JSON.stringify(selectedOptions));

        dispatch(updateProfile(formData));
      }

      onHide();
    } else {
      // ✅ Profile page → always API
      const formData = new FormData();

      formData.append(
        "name",
        store?.profileItem?.data?.name ||
          store?.profileItem?.data?.full_name ||
          "",
      );

      formData.append("emr_systems", JSON.stringify(selectedOptions));

      dispatch(updateProfile(formData));
    }
  };
  // const handleSave = () => {
  //   if (!selectedOptions.length) {
  //     setError("Please select at least one EMR system");
  //     return;
  //   }

  //   if (isApplyPage) {
  //     // ✅ LOCAL UPDATE
  //     onSave(selectedOptions);
  //     onHide();
  //   } else {
  //     // ✅ API CALL
  //     const formData = new FormData();

  //     formData.append(
  //       "name",
  //       store?.profileItem?.data?.name ||
  //         store?.profileItem?.data?.full_name ||
  //         "",
  //     );

  //     formData.append("emr_systems", JSON.stringify(selectedOptions));

  //     dispatch(updateProfile(formData));
  //   }
  // };
  /* -------- CLOSE AFTER SAVE -------- */
  useEffect(() => {
    if (store?.actionFlag === "PROFILE_UPDT_SCS") {
      onHide();
    }
  }, [store?.actionFlag]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      dialogClassName="custom-modal profile-other-details-modal"
    >
      <Modal.Header>
        <h5 className="modal-title">Select EMR Systems Experience</h5>

        <Button className="close-btn" onClick={onHide}>
          <FiX size={24} />
        </Button>
      </Modal.Header>

      <Modal.Body>
        <div className="checkbox-options">
          <div className="row">
            {emrOptions.map((option) => (
              <div
                key={option.value}
                className={`checkbox-option col-lg-6 ${
                  selectedOptions.includes(option.value) ? "selected" : ""
                }`}
                onClick={() => handleSelect(option.value)}
              >
                <div className="contentwrap">
                  <input
                    type="checkbox"
                    checked={selectedOptions.includes(option.value)}
                    readOnly
                  />

                  <label className="checkbox-label">{option.label}</label>
                </div>
              </div>
            ))}
          </div>
        </div>

        {error && <div className="error-message mt-2">{error}</div>}

        <div className="text-center mt-4">
          <Button
            className="btn-primary px-4"
            onClick={handleSave}
            disabled={store?.isLoading || selectedOptions.length === 0}
          >
            {store?.isLoading ? "Saving..." : "Save"}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default EmrSystemsModal;
